import type { TrackCustomEventProps, TrackUAEventProps } from "utils/tracking/utils.d";

export const CONNECTING_FLIGHT_ADD_CLICK_EVENT_UA: TrackUAEventProps = [
  "clicked",
  "hero_form",
  "add_connecting_flight",
];
export const CONNECTING_FLIGHT_ADD_CLICK: TrackCustomEventProps = {
  event: "page_interactions",
  label: "add_connecting_flight",
  placement: "hero_form",
};

export const CONNECTING_FLIGHT_DIRECT_TAB_CLICK_EVENT_UA: TrackUAEventProps = ["clicked", "hero_form", "direct_flight"];
export const CONNECTING_FLIGHT_DIRECT_TAB_CLICK: TrackCustomEventProps = {
  event: "page_interactions",
  label: "direct_flight",
  placement: "hero_form",
};

export const CONNECTING_FLIGHT_MULTILEG_TAB_CLICK_EVENT_UA: TrackUAEventProps = [
  "clicked",
  "hero_form",
  "connecting_flight",
];
export const CONNECTING_FLIGHT_MULTILEG_TAB_CLICK: TrackCustomEventProps = {
  event: "page_interactions",
  label: "connecting_flight",
  placement: "hero_form",
};
